// How many customers are at an address.
//
// List views used to print the single owner's name. A location can now serve
// several subscribers (0032), and a name column can't say that without either
// truncating or growing unboundedly — so lists show a count and the detail page
// shows the names. The pill is a link to the location, which is where the
// answer to "who?" actually lives.
//
// Nobody linked reads "unassigned", in grey and not as a pill: an empty address
// is a state, not a quantity, and the pool filter already keys off it.

import { Link } from 'react-router-dom';

export default function SubscriberCountPill({ count, locationId, subscribers }) {
  const n = Number(count ?? (Array.isArray(subscribers) ? subscribers.length : 0)) || 0;
  if (n === 0) return <span className="text-gray-400">unassigned</span>;

  const shared = n > 1;
  const names = Array.isArray(subscribers) && subscribers.length
    ? subscribers.map((s) => s.name).filter(Boolean).join(', ')
    : null;
  const label = `${n} ${n === 1 ? 'customer' : 'customers'}`;
  // Shared addresses are the ones worth noticing — a second tenant at one
  // dispatch address changes how E911 and teardown behave.
  const cls = shared
    ? 'bg-amber-50 text-amber-800 ring-amber-200'
    : 'bg-gray-100 text-gray-700 ring-gray-200';

  const pill = (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${cls}`}
      title={names ? `${label}: ${names}` : label}
    >
      {shared && (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round" className="h-3 w-3" aria-hidden="true">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )}
      {label}
    </span>
  );

  return locationId
    ? <Link to={`/locations/${locationId}`} className="hover:opacity-80">{pill}</Link>
    : pill;
}
